/* eslint-disable sort-keys */
import { CFTokens } from '../../../../tokens';
export const TEXT_COLOR = {
    DEFAULT: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
    PLACEHOLDER: CFTokens.COLOR.TEXT_AND_ELEMENT_HINT,
};
export const TYPE_SPEC = {
    DEFAULT: CFTokens.TYPE_SPEC.BODY.SM,
    LG: Object.assign(Object.assign({}, CFTokens.TYPE_SPEC.BODY.SM), { fontSize: CFTokens.FONT_SIZE.H }),
};
